<script setup lang="ts">
import { ref } from "vue";
import { useRouter } from "vue-router";
import { UiButton, UiText, useApi } from "@shopexperts/shared";
import { captureConvexError } from "../telemetry";

const props = defineProps<{ recipientOrgId: number; side: "client" | "expert" }>();
const api = useApi();
const router = useRouter();
const pending = ref(false);
const error = ref<string | null>(null);
async function open() {
  if (pending.value) return;
  pending.value = true;
  error.value = null;
  try {
    const room = await api.directChatrooms.open({ body: { recipient_org_id: props.recipientOrgId } });
    await router.push(`/${props.side}/messages/${room.thread_id}`);
  } catch (cause) {
    error.value = "Unable to open this conversation. Please try again.";
    captureConvexError(cause, { operation: "chat.open_direct_room", level: "error" });
  } finally { pending.value = false; }
}
</script>

<template>
  <div class="flex flex-col gap-1">
    <UiButton variant="outline" :label="pending ? 'Opening…' : 'Direct message'" :disabled="pending" @click="open" />
    <UiText as="p" v-if="error" variant="small" :text="error" role="alert" />
  </div>
</template>
